import * as React from 'react';

export default class FormDivider extends React.PureComponent {
  public render() {
    return (
      <hr className="formdivider" />
    );
  }
}
